import React, { FC, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { IChannel, ISelection } from "../helper";
import config from "../../../../config";
import { WebsiteChannel, EmailChannel, QrChannel } from "../common";

interface Props {
  group: any;
  channel: IChannel;
  selections: Array<ISelection>;
  setSelections: (data: Array<any>) => void;
}

export const MediaCarousalDetails: FC<Props> = (props) => {
  const { projectId } = useParams();
  const { group, channel } = props;

  const iframeUrl = useMemo(
    () => `${config.EMBED_HOST}/assets/js/e2.js?source=embed&p=${projectId}`,
    [projectId]
  );

  useEffect(() => {
    /* @ts-ignore */
    window.tdcEmbedLoaded = false;
    /* @ts-ignore */
    window.tdcEmbedSingleLoaded = false;
    const script = document.createElement("script");
    script.src = iframeUrl;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [iframeUrl, channel]);

  const carousalTagProps = useMemo(
    () => ({
      class: "tdc2",
      bid: group?.brand?.id,
      eid: group.id,
      b: group?.brand?.slug,
      e: group.name?.replace(/\s+/g, "-").toLowerCase(),
      type: `text/javascript`,
      src: iframeUrl,
    }),
    [iframeUrl, group]
  );

  const formatLandingUrl = (source: string = "landing") =>
    `${config.EMBED_HOST}/brands/${group?.brand?.id}/${
      group?.brand?.slug ?? "-"
    }/landing/${group?.id}/${group?.name}?source=${source}&p=${projectId}`;

  return (
    <Box className="mt-8 flex flex-col xl:flex-row" gap={6}>
      <Box className="w-[300px] px-2 shrink-0">
        <script {...carousalTagProps} />
      </Box>

      <Box className="w-full px-2">
        <Typography gutterBottom component="div">
          <strong>{channel?.name}</strong>
        </Typography>

        {channel?.name === "Email/Text" && (
          <EmailChannel group={group} url={formatLandingUrl("landing")} />
        )}

        {channel?.name === "QR" && <QrChannel url={formatLandingUrl("qr")} />}

        {channel?.name === "Website" && (
          <WebsiteChannel
            iframeUrl={iframeUrl}
            scriptTagProps={carousalTagProps}
          />
        )}
      </Box>
    </Box>
  );
};
